var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.Layout
  }, [_c('Nuxt', {
    class: _vm.$style.page
  }), _vm._v(" "), _c('AppFooter'), _vm._v(" "), _c('client-only', [_c('ScrollUpButton'), _vm._v(" "), _c('NotificationsContainer'), _vm._v(" "), _c('TheModal'), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "layout",
      "multiple": ""
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };